/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DefaultVipDiscountPutDto } from '../../models/default-vip-discount-put-dto';
import { DefaultVipDiscountResponseModel } from '../../models/default-vip-discount-response-model';

export interface UpdateDefaultVipDiscount$Params {
  defaultVipDiscountId: string;
      body: DefaultVipDiscountPutDto
}

export function updateDefaultVipDiscount(http: HttpClient, rootUrl: string, params: UpdateDefaultVipDiscount$Params, context?: HttpContext): Observable<StrictHttpResponse<DefaultVipDiscountResponseModel>> {
  const rb = new RequestBuilder(rootUrl, updateDefaultVipDiscount.PATH, 'put');
  if (params) {
    rb.path('defaultVipDiscountId', params.defaultVipDiscountId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DefaultVipDiscountResponseModel>;
    })
  );
}

updateDefaultVipDiscount.PATH = '/discounts/vip/defaults/{defaultVipDiscountId}';
